/* eslint eqeqeq: "off" */
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import toastr from 'toastr';
import $ from 'jquery';

import CargarRegistros from './CargarRegistros';

import * as showSidebarIzquierdaActions from '../../actions/showSidebarIzquierdaActions';
import * as userActions from '../../actions/userActions';
import * as paginaActions from '../../actions/paginaActions';
import * as menuActions from '../../actions/menuActions';
import * as constanciaExternaActions from '../../actions/constanciaExternaActions';


import { Segment} from 'semantic-ui-react';
import {usuarioActual} from '../../util';
import {genericFormattedForDropdown} from '../../selectors/selectors';
import {getMargenes} from '../../util/';
import moment from 'moment';

class ManageCargarRegistros extends React.Component {
    constructor(props, context) {
		
		super(props, context);
        this.state={
            errors:{},
            cargar:{}
		};
	}

	componentDidMount(){
      
        usuarioActual(this, "cargar",true).then( (usuario)=>{
            
           
           
            
	   })
    }

   
    onChangeAdjunto = (event, data) => {
        let mvalue = this.state.mvalue;
        let datos = this.state.datos;
        var field;
        var value;

        if (data.type == "file") {
          let file = event.target.files[0];
          if (!file) {
            return;
          }

          if (event.target.files[0].size <= 1024000) {
            this.setState({
              adjunto: event.target.files[0],
            });
          } else {
            toastr.error("No se permiten imagenes mayores a 1 Mb!!!");
            return;
          }
        }
      };
    
    
    handleChange=(event, data)=> {

        let cargar = this.state.cargar;
        let field= data.name;		
        let value;
    
        if(data.type == 'radio'){
            value=	data.checked;		
        }else{
            value=	data.value;		
        }
        
        if(data.toggle){
            if(data.checked){
                value = 1;
            }else{
                 value = 2
            }
        }
        
        
        field=field.split('.');
		if(field.length==1)
      		cargar[field[0]]= value;
		else{
             if(!cargar[field[0]]){
                    cargar[field[0]]={}
                }
			cargar[field[0]][field[1]]= value;
		}
        
        if(field == 'cursoId'){
            this.setState({"cursoId":value});            
    
            
        }

        this.setState({"cargar": cargar});
    }

    cargarInformacion = (event) => {
        event.preventDefault();
        var adjunto = this.state.adjunto;
        
        if (adjunto instanceof File) {
            var form_data = new FormData();
            form_data.append("file", adjunto);
            //form_data.append("opcion", JSON.stringify(datos));

            this.props.constanciaExternaActions.saveAdjunto(form_data, this.props.user )
              .then(() => {
                
                toastr.info("El archivo fue cargado exitosamente");
                
                })
              .catch((error) => {
                toastr.error(error.responseJSON.message);
              });
        } else {
            toastr.error("Debes adjuntar el documento!!!!");
        }
        
  };
    
    render() {
       
        let margenes=getMargenes(this.props.showSidebarIzquierda, this.props.sidebarIzquierda); 
		return (
            <Segment   style={margenes}>
                 
                <CargarRegistros
                    strings={this.props.strings}
                    ajaxCallInProgress={this.props.ajaxCallInProgress}
                    id={this.state.id}
                    errores={this.state.errores}
                    onChange={this.handleChange}
                    onChangeAdjunto={this.onChangeAdjunto}
                    cargarInformacion={this.cargarInformacion}
                   
                />
                
             
            

            </Segment> 
            
		);
	}
    
}

            
            
function mapStateToProps(state, ownProps){
    
  
    
    return {
          

        showSidebarIzquierda: state.showSidebarIzquierda,
        sidebarIzquierda: state.sidebarIzquierda,
        ajaxCallInProgress:state.ajaxCallInProgress,
        color:state.color,
        form:state.form,
        color:state.color,
        strings:state.strings,
        idioma:state.idioma,
        user:state.user

    }

}


function mapDispatchToProps(dispatch){

	return { 
        menuActions:bindActionCreators(menuActions, dispatch),
        paginaActions: bindActionCreators(paginaActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        constanciaExternaActions:bindActionCreators(constanciaExternaActions, dispatch)

 	};
}


export default connect (mapStateToProps, mapDispatchToProps)(ManageCargarRegistros);